import { render, staticRenderFns } from "./typeBBtn.vue?vue&type=template&id=05e2b4c3"
import script from "./typeBBtn.vue?vue&type=script&lang=js"
export * from "./typeBBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports